import React from "react";
import style from "./index.module.scss";
import ListItemSimple from "./components/ListItemSimple";
import CustomEmpty from "../CustomEmpty";
import classNames from "classnames";

interface StuListItem {
    name: string;
    studentNo: string;
    status: any;
}

interface StuListSimpleProps {
    data: StuListItem[];
    className?: string;
    renderStatus: (item: StuListItem) => React.ReactNode;
}

export default function StuListSimple({
    data,
    className,
    renderStatus
}: StuListSimpleProps) {
    return (
        <div className={classNames(style.root, className)}>
            <div className={style.wrapper}>
                {data.map(item => (
                    <ListItemSimple
                        key={item.studentNo}
                        name={item.name}
                        studentNo={item.studentNo}
                        status={renderStatus(item)}
                    />
                ))}
                {data.length === 0 && <CustomEmpty />}
            </div>
        </div>
    );
}
